import { Navigate, useLocation, useParams } from 'react-router-dom';
import Home from './pages/Home';
import Search from './pages/Search';
import ProductDetail from './pages/ProductDetail';
import Compare from './pages/Compare';
import Cart from './pages/Cart';
import Checkout from './pages/Checkout';
import OrderConfirmed from './pages/OrderConfirmed';
import Login from './pages/Login';
import Account from './pages/Account';
import Orders from './pages/Orders';
import OrderDetail from './pages/OrderDetail';
import RepairBooking from './pages/RepairBooking';
import RepairTracker from './pages/RepairTracker';
import MyRepairs from './pages/MyRepairs';
import Warranty from './pages/Warranty';
import Sell from './pages/Sell';
import Quote from './pages/Quote';

/** Laptop-era links (/laptops?…, /laptops/:id, landing pages, bookmarks) keep working (B11-P3). */
function LaptopsRedirect() {
  const { search } = useLocation();
  return <Navigate to={`/shop/laptops${search}`} replace />;
}
function LaptopRedirect() {
  const { id } = useParams();
  return <Navigate to={`/p/${id}`} replace />;
}

/**
 * Storefront route manifest (owned by the storefront surface).
 * { path, Element, prd, auth } — rendered inside StorefrontApp's layout; `store`
 * is injected. `auth: true` routes need the customer's OTP session (C-05:
 * guests browse freely; /checkout runs the phone OTP step inline).
 * A route under a store feature's paths (D101: /repair, /sell, declared on the server
 * and served as store.feature_paths) is mounted only while that feature is on
 * (lib/features), except the patterns it keeps (store.feature_kept_paths): with repairs
 * off a shopper still opens their own repair at /repair/:id, and /account/repairs lists
 * them. /warranty is always on; /quote is a bulk-quote lead, not buy-back.
 */
export const storefrontRoutes = [
  { path: '/', Element: Home, prd: 'WEB-01' },
  { path: '/shop', Element: Search, prd: 'WEB-02' },
  { path: '/shop/:type', Element: Search, prd: 'WEB-02' },
  { path: '/p/:id', Element: ProductDetail, prd: 'WEB-03' },
  { path: '/laptops', Element: LaptopsRedirect, prd: 'WEB-02' },
  { path: '/laptops/:id', Element: LaptopRedirect, prd: 'WEB-03' },
  { path: '/compare', Element: Compare, prd: 'WEB-04' },
  { path: '/cart', Element: Cart, prd: 'WEB-05' },
  // Guests verify their phone inside checkout (MERCH-56); the server still requires the customer session.
  { path: '/checkout', Element: Checkout, prd: 'WEB-05' },
  { path: '/checkout/confirmed/:id', Element: OrderConfirmed, prd: 'WEB-05', auth: true },
  { path: '/account/login', Element: Login, prd: 'WEB-06' },
  { path: '/account', Element: Account, prd: 'WEB-06', auth: true },
  { path: '/account/orders', Element: Orders, prd: 'WEB-07', auth: true },
  { path: '/account/orders/:id', Element: OrderDetail, prd: 'WEB-07', auth: true },
  { path: '/account/repairs', Element: MyRepairs, prd: 'WEB-09', auth: true },
  { path: '/repair', Element: RepairBooking, prd: 'WEB-08' },
  { path: '/repair/:id', Element: RepairTracker, prd: 'WEB-09', auth: true },
  { path: '/warranty', Element: Warranty, prd: 'WEB-10' },
  { path: '/sell', Element: Sell, prd: 'WEB-11' },
  { path: '/quote', Element: Quote, prd: 'SELL-06' },
];
